import script from "./super-admin-company-table.vue?vue&type=script&setup=true&lang=js"
export * from "./super-admin-company-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__